import { POST, POST_CLAIM_WARRANTY_VERIT } from '../..';
import { useQuery } from '@tanstack/react-query';
import { openAlert } from '../../../components/alert/hooks';
import { MONITOR_LARK } from '../../../helpers/lark';

export const getClaimWarrantyVerify = (warrantyId, warrantyCode) =>
  useQuery({
    queryKey: ['getClaimWarrantyVerify'],
    queryFn: async () => {
      try {
        const data = { warrantyId, warrantyCode };
        const response = await POST(POST_CLAIM_WARRANTY_VERIT, data);

        if (response.success) {
          return response?.result;
        }
      } catch (error) {
        openAlert({ model: 'notification', type: 'error', message: error.message });
        MONITOR_LARK({
          module: 'getClaimWarrantyVerify',
          message: `${POST_CLAIM_WARRANTY_VERIT} : GET ERROR!!`,
          error,
        });
      }
    },
    enabled: false,
    retry: 1,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
